import {Box, Stack, Typography} from "@mui/material"
import {useSistemas, useSistemasPrincipal} from "src/pages/messages/api"
import {EntityWithIdAndDescriptionFields, EntityWithIdFields} from "src/types"
import {CountryAvatar} from "../../../../components/icons/CountryAvatar";

export const InfoNuevoMensajeMobile = ({
                                         codSistemaPrincipal,
                                         codSistema,
                                           codSistemaTipo
                                       }: { codSistemaPrincipal: number, codSistema: number, codSistemaTipo: number }) => {
  const {sistemasPrincipal} = useSistemasPrincipal()
  const {sistemas} = useSistemas(true)

  if (!sistemasPrincipal || !sistemas)
    return <div></div>

  const sistemaPrincipal = sistemasPrincipal.find(sistema => sistema[EntityWithIdFields.Id] === codSistemaPrincipal)
  const sistemaActual = sistemas.find(sistema => sistema[EntityWithIdFields.Id] === codSistemaTipo)

  return (
    <Box flexShrink={1} overflow='hidden'>
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <Stack direction='row' display='flex' alignItems='center' spacing={1} minWidth={0}>
          <CountryAvatar
            countryCode={codSistemaPrincipal}
            sx={{height: '15px', width: '15px'}}
          />
          <Typography noWrap sx={{minWidth: 0}}>
            {sistemaActual?.[EntityWithIdAndDescriptionFields.Description]}
          </Typography>
        </Stack>
      </Box>
    </Box>
  )
}
